import script from "./singleBlogContent.vue?vue&type=script&setup=true&lang=js"
export * from "./singleBlogContent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__